import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import * as Icons from "react-bootstrap-icons";

export default function BankTransactionCallBack({status, RetrivalRefNo, SystemTraceNo}) {
    const [sec, setSec] = useState(10);
    const { t } = useTranslation();
    useEffect(() => {
        if (sec > 1) {
            setTimeout(() => {
                setSec(sec - 1);
            }, 1000);
        } else if(sec === 1) {
            handleOpenApp();
        }
    }, [sec]);
    const handleOpenApp = () => {
        setSec(0);
        window.open('soundcloud:',"_blank","location=yes");
    }
    return (
        <>
            <div className="d-flex flex-column justify-content-center align-items-center shadow-lg py-4 px-4 mx-4" style={{'minWidth':'350px', 'minHeight':'150px', 'borderRadius':'10px'}}>
                {
                    status
                    ? <div className="text-center">
                        <div className="text-success mb-3">
                            <Icons.CheckCircle size={90} />
                        </div>
                        <strong style={{'fontSize':'16px'}}>
                            {t('successfulPayment')}
                        </strong>
                        {
                            (RetrivalRefNo && SystemTraceNo) &&
                            <p className="m=0 mt-2">
                                {`${t('payment_reference_number')}: ${RetrivalRefNo}`}
                                <br/>
                                {`${t('payment_tracking_number')}: ${SystemTraceNo}`}
                            </p>
                        }
                    </div>
                    : <div className="text-center">
                        <div className="text-danger mb-3">
                            <Icons.XCircle size={90}/>
                        </div>
                        <strong style={{'fontSize':'16px'}}>
                            {t('payment_error')}
                        </strong>
                        <p className="m=0 mt-2">
                            {t('payment_problem')}
                            <br/>
                            {t('payment_tryAgain')}
                        </p>
                    </div>
                }
                <div className={`mt-3 w-100 btn ${status ? 'btn-outline-success' : 'btn-outline-danger'}`} onClick={handleOpenApp}>
                    {`${t('payment_BackMobile')} (${sec})`}
                </div>
            </div>
            <div className="text-center fixed-bottom mb-5">
                <span>
                    {t('payment_choosing')}
                </span>
            </div>
        </>
    );
}
